// extracted by mini-css-extract-plugin
module.exports = {"batchFirst":"bulk-landing_batchFirst__XtbRA","lead":"bulk-landing_lead__9OC6K"};